import { DocumentTypeEnum, DriveEventActionEnum } from '@workalizer/shared';
import { getDocumentType } from '@workalizer/shared/services/processMeetingsAnalytic';
export var analyticDriveActivity = function (documents, groupedEvents) {
    var _a;
    var documentMap = new Map(documents.map(function (doc) { return [doc.id, { title: doc.title, type: doc.type }]; }));
    var actionCategoryMap = (_a = {},
        _a[DriveEventActionEnum.DOCUMENT_EDIT] = 'edited',
        _a[DriveEventActionEnum.DOCUMENT_RENAME] = 'edited',
        _a[DriveEventActionEnum.DOCUMENT_VIEW] = 'viewed',
        _a[DriveEventActionEnum.DOCUMENT_CREATE_COMMENT] = 'commented',
        _a[DriveEventActionEnum.DOCUMENT_DELETE_COMMENT] = 'commented',
        _a[DriveEventActionEnum.DOCUMENT_CREATE_SUGGESTION] = 'suggested',
        _a[DriveEventActionEnum.DOCUMENT_ACCEPT_SUGGESTION] = 'suggested',
        _a);
    var groupedData = groupedEvents.reduce(function (acc, _a) {
        var documentId = _a.documentId, action = _a.action, _count = _a._count;
        var _b = documentMap.get(documentId) || {
            title: '',
            type: DocumentTypeEnum.OTHER
        }, title = _b.title, type = _b.type;
        var categoryKey = actionCategoryMap[action] || 'other';
        var category = acc[categoryKey];
        var existingDoc = category.find(function (event) { return event.documentId === documentId; });
        if (existingDoc) {
            existingDoc.actionCount += _count.action;
        }
        else {
            category.push({
                documentId: documentId,
                action: categoryKey === 'other'
                    ? undefined
                    : action,
                title: title,
                actionCount: _count.action,
                type: getDocumentType(type)
            });
        }
        return acc;
    }, {
        edited: [],
        viewed: [],
        commented: [],
        suggested: [],
        other: []
    });
    return groupedData;
};
